import { IStyle, mergeStyleSets } from "@fluentui/react";

export const styles = mergeStyleSets({
  customerEngagement: {
    height: 600
  } as IStyle
});